<template>
  <!-- 工单详情 -->
  <div class="smy__card-full-box">
    <Card
      class=""
      :bordered="false"
      :padding="0"
      >
      <p slot="title">
        发票详情
      </p>
      <div class="top" style="padding: 10px 16px">
        <Button
          type="ghost"
          icon="ios-undo"
          @click="back"
        >返回</Button>
      </div>
    </Card>
      <div class="content">
        <Card
          class="smy__card-full card-left"
          :bordered="false"
          >
          <InvoiceDetailLeft
          :invoiceListDetail="invoiceListDetail"
          />
        </Card>
        <div  class="smy__card-full card-right">
          <Card
            :bordered="false"
            style="margin-top:11px"
            >
            <InvoiceDetailRight
              ref="orderDetailRight"
              :invoiceListDetail="invoiceListDetail"
            />
          </Card>
        </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'

import InvoiceDetailLeft from './InvoiceDetailLeft'
import InvoiceDetailRight from './InvoiceDetailRight'

export default {
  components: {
    InvoiceDetailLeft,
    InvoiceDetailRight
  },
  props: {
    orderId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      orderDetail: {},
      buyPeople: [],
      invoiceListDetail: {}
    }
  },
  methods: {
    back () {
      this.$router.back()
    }
  },
  created () {
  },
  beforeRouteEnter (to, from, next) {
    axios.get(`/invoice//info/${to.params.orderId}`).then(res => {
      next(vm => {
        vm.invoiceListDetail = res.data
      })
    })
  }
}
</script>

<style lang="less" scoped>
.content {
  margin-top: 10px;
  flex: 1;
  display: flex;
  align-items: stretch;

  .card-left {
    width: 300px;
    height: 100%;
    flex-shrink: 0;
  }

  .card-right {
    width: 100%;
    margin-left: 10px;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/handle/isuseInvoiceHandle/invoiceDetail.vue